import BlogSearch from '@/components/pages/blog/blogsContent/BlogSearch';
import React, { useEffect, useState } from 'react';
import styles from './styles.module.css';
import AppLink from '@/components/common/AppLink';
import BadgeCard from '@/components/general/BadgeCard';
import { country, setState } from '@/commonTypes';
import MoreTagButton from '@/components/pages/blog/blogsContent/BlogsFiltersSection/MoreTagButton';
import { useTranslations } from 'next-intl';
import Api from '@/api';
import DynamicSelectSort from '@/components/common/dynamicSelect/dynamicSelectSort';
import ViewportWrapper from '@/components/structure/ViewportWrapper';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';

export default function BrandSearch({
  country = '',
  pageNumber,
  setPageNumber,
}: {
  country?: string;
  pageNumber?: number | string;
  setPageNumber: setState<number | string>;
}) {
  // const [showMore, setShowMore] = useState(false);
  const [list, setList] = useState<any[]>([{ id: 0, name: 'همه', slug: '' }]);
  const [countryValue, setCountryValue] = useState<any>(
    country ? { id: -1, name: country?.trim(), slug: '' } : undefined,
  );

  useEffect(() => {
    Api.brandCountries()
      .then((res: any) => {
        const countries = res?.data?.response || [];
        setList([
          { id: 0, name: 'همه', slug: '' },
          ...countries.map((item: any, index: number) => ({
            id: index + 1,
            name: item?.country,
            slug: item?.country,
          })),
        ]);
      })
      .catch((err) => {
        console.error('brandCountries failed:', err);
      });
  }, []);

  useEffect(() => {
    setCountryValue(country ? { id: -1, name: country?.trim(), slug: '' } : undefined);
  }, [country]);
  const tCommon = useTranslations('common');
  console.log('country==', countryValue);
  // const sliceNumber = 5;

  // const countryList: any = list ? (showMore ? list : list?.slice(0, sliceNumber)) : [];
  const searchParams = useSearchParams();
  const router = useRouter();
  const pathname = usePathname();
  const item: any = {
    type: 'myselectSort',
    id: 'country',
    classMain: ` ${styles.wfull} ${styles.itemMargin}`,
    key: 'country',
    value: countryValue,
    apiCategory: [
      {
        id: 1,
        searchkey: 'name',
        listTitleKey: ['name'],
        // searchkey: 'title',
        // listTitleKey: ['title'],
        // apiParams: { start: 0, limit: 10, name: country ? country : null },
        // apiCall: Api.countryList,
        options: list,
        placeholder: 'کشور',
      },
    ],
  };
  // const [item, setItem] = useState<any>({
  //   type: 'myselectSort',
  //   id: 'country',
  //   classMain: ` ${styles.wfull} ${styles.itemMargin}`,
  //   key: 'country',
  //   value: countryValue,
  //   apiCategory: [
  //     {
  //       id: 1,
  //       searchkey: 'name',
  //       listTitleKey: ['name'],
  //       // searchkey: 'title',
  //       // listTitleKey: ['title'],
  //       apiParams: { start: 0, limit: 10, name: country ? country : null },
  //       apiCall: Api.countryList,
  //       // options: list,
  //       placeholder: 'کشور',
  //     },
  //   ],
  // });

  // useEffect(() => {
  //   setItem({
  //     type: 'myselectSort',
  //     id: 'country',
  //     classMain: ` ${styles.wfull} ${styles.itemMargin}`,
  //     key: 'country',
  //     value: countryValue,
  //     apiCategory: [
  //       {
  //         id: 1,
  //         // searchkey: 'name',
  //         // listTitleKey: ['name'],
  //         searchkey: 'name',
  //         listTitleKey: ['name'],
  //         apiParams: { start: 0, limit: 10, name: country ? country : null },
  //         // apiCall: Api.countryList,
  //         options: list,
  //         placeholder: 'کشور',
  //       },
  //     ],
  //   });
  // }, [country, countryValue]);
  // console.log('countryValue========', countryValue);
  return (
    <div className={`card ${styles.container}`}>
      <BlogSearch
        page="/brands"
        className={`${styles.search}`}
        // className="darkSearch"
        placeholder="جستجوی برند"
        affix={<></>}
        // setPageNumber={setPageNumber}
      />

      <DynamicSelectSort
        // searchValue={country}
        item={item}
        classContainer={styles.select}
        propsValue={item?.value}
        onSelect={(item?: country) => {
          const params = new URLSearchParams(searchParams.toString());
          // let countryTitle = list?.filter((x) => x?.id == item?.id)?.[0]?.title;
          console.log('country======', item);
          if (!item?.name || item?.name?.trim()?.length == 0 || item?.name == 'همه') {
            // if (!item?.title || item?.title?.trim()?.length == 0 || item?.title == 'همه') {
            params.delete('country');
          } else {
            params.set('country', item?.name);
          }
          params.set('page', '1');
          setPageNumber(1);
          const newPath = pathname.replace(/\/page\/\d+$/, '');
          // setCountryValue(item);
          router.push(`${newPath}${params.toString() ? `?${params.toString()}` : ''}`);
        }}
        apiCategory={item?.apiCategory}
      />
    </div>
  );
}
